import assert from 'assert';
import { useMemo } from 'react';
import { TimeSignal } from 'graphql/types';

interface UseGroupTimePeriodReturnProps {
  groupStartTime: string | undefined;
  groupEndTime: string | undefined;
}

export const useGroupTimePeriod = (
  notes: TimeSignal[]
): UseGroupTimePeriodReturnProps => {
  return useMemo(() => {
    if (process.env.NODE_ENV === 'production') {
      if (notes.length === 0) {
        return {
          groupStartTime: undefined,
          groupEndTime: undefined
        };
      }
    } else {
      assert(notes.length > 0);
    }

    let currentStartTime: string | undefined = undefined;
    let currentEndTime: string | undefined = undefined;
    notes.forEach((note: TimeSignal) => {
      if (!currentStartTime || note.startTime < currentStartTime) {
        currentStartTime = note.startTime;
      }
      if (!currentEndTime || note.endTime > currentEndTime) {
        currentEndTime = note.endTime;
      }
    });

    return {
      groupStartTime: currentStartTime,
      groupEndTime: currentEndTime
    };
  }, [notes]);
};
